"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _image = _interopRequireDefault(require("@/components/customPage/image.vue"));
var _upload = _interopRequireDefault(require("./upload.vue"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _createNamespacedHelp = (0, _vuex.createNamespacedHelpers)('picture'),
  mapState = _createNamespacedHelp.mapState,
  mapActions = _createNamespacedHelp.mapActions,
  mapMutations = _createNamespacedHelp.mapMutations;
var _default = {
  components: {
    Picture: _image.default,
    Upload: _upload.default
  },
  inject: ['uploader'],
  data: function data() {
    return {
      keyword: '',
      pageSize: 5,
      pageTotal: 0,
      pageCurrent: 1
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: (0, _objectSpread2.default)({}, mapState(['classify', 'pictures', 'pageInfo', 'classifyInfo'])),
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.uploader.selectClassify == '') {
              this.uploader.selectClassify = this.classify[0].id;
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, mapMutations(['setClassifyInfo'])), mapActions(['handlePictures'])), {}, {
    /**
     * 上传成功
     * @return {[type]} [description]
     */
    handleSuccess: function handleSuccess() {},
    /**
     * 分页
     * @return {[type]} [description]
     */
    handleSizeChange: function handleSizeChange() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (this.uploader.selectClassify == '') {
        this.uploader.selectClassify = this.classify[0].id;
      }
      this.handlePictures({
        id: this.uploader.selectClassify,
        current: e,
        pageSize: 15
      });
    },
    /**
     * 双击事件
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    handleChange: function handleChange(e) {
      var _this = this;
      this.handlePictures({
        id: e.id,
        current: 1,
        pageSize: 15
      }).then(function () {
        _this.uploader.selectClassify = e.id;
        _this.setClassifyInfo({
          id: e.id,
          name: e.title_name
        });
      });
    },
    uploadFile: function uploadFile(e) {
      var _this2 = this;
      //此处执行POST提交方法
      return new Promise(function (reslove, reject) {
        //将文件流数据转Base64数据
        var oFReader = new FileReader();
        oFReader.readAsDataURL(e);
        oFReader.onload = function (oFREvent) {
          _this2.$heshop.uploadV2({
            type: 1,
            group_id: _this2.uploader.selectClassify,
            content: oFREvent.target.result
          }).then(function (data) {
            console.error('返回数据', data);
            reslove(data);
          }).catch(function (error) {
            reject(error);
          });
        };
      });
    }
  })
};
exports.default = _default;